import React from 'react';
import { IonCard, IonList, IonListHeader, IonLabel } from '@ionic/react';
import UpcomingEventRow from './UpcomingEventRow';
import { UpcomingEvent } from '../../../models';
import './UpcomingEventsSection.css';

interface Props {
    events: UpcomingEvent[];
}

const UpcomingEventsSection: React.FC<Props> = ({ events }) => {
    if (events.length === 0) {
        return null;
    }

    return (
        <IonCard className="upcoming-events-section">
            <IonList lines="full">
                <IonListHeader>
                    <IonLabel>Upcoming Events</IonLabel>
                </IonListHeader>
                {events.map(event => (
                    <UpcomingEventRow key={`upcoming-event-${event.id}`} event={event} />
                ))}
            </IonList>
        </IonCard>
    );
};

export default UpcomingEventsSection;
